export default __webpack_public_path__ + "static/f2-24bc9c940a98f0f5faf91894eee8433d.png";